import { createFileRoute } from '@tanstack/react-router';

// relative imports
import TaxPlanningPageContainer from '../../../../../components/portfolio-planning/TaxPlanningPageContainer';
import LoadingPage from '../../../../../components/shared/page-components/LoadingPage';

export const Route = createFileRoute(
  '/_authenticated/client/$accountId/_clientWrapper/planning',
)({
  pendingComponent: () => <LoadingPage loadingPage />,
  component: TaxPlanningPageContainer,
  staticData: {
    configPageId: 'planning',
    isClientRoute: true,
    meta: {
      title: 'Client Planning | Ledgible',
    },
  },
});
